import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { CalendarCheck, Activity, AlertCircle } from "lucide-react";

export default function Compliance() {
  const [items, setItems] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    (async () => {
      const [c, p] = await Promise.all([api.get("/compliance"), api.get("/projects")]);
      setItems(c.data);
      setProjects(p.data);
    })();
  }, []);

  const projName = (id) => projects.find((p) => p.id === id)?.project_name || "—";
  const today = new Date().toISOString().slice(0, 10);

  const grouped = items.reduce((acc, i) => {
    (acc[i.type] = acc[i.type] || []).push(i);
    return acc;
  }, {});

  return (
    <div className="space-y-6 animate-fade-up">
      <div>
        <p className="text-xs uppercase tracking-[0.22em] text-emerald-700 font-semibold mb-2">Post-EC operations</p>
        <h1 className="text-4xl font-bold tracking-tight text-stone-900" style={{ fontFamily: "Bricolage Grotesque" }}>Compliance Calendar</h1>
        <p className="text-stone-500 mt-2">Track PMR, Six Monthly, EC Conditions, Form-V and more across projects.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Object.entries(grouped).map(([type, list]) => (
          <div key={type} className="bg-white border border-stone-200 rounded-xl p-5">
            <div className="flex items-center justify-between mb-4">
              <div className="font-semibold text-stone-900 flex items-center gap-2">
                <CalendarCheck className="w-4 h-4 text-emerald-700" /> {type}
              </div>
              <span className="text-xs bg-stone-100 px-2 py-0.5 rounded-full font-medium">{list.length}</span>
            </div>
            <div className="space-y-2">
              {list.map((c) => {
                const overdue = c.due_date < today && c.status !== "Completed";
                return (
                  <div key={c.id} data-testid={`compliance-${c.id}`} className="border border-stone-100 rounded-lg p-3">
                    <div className="text-sm font-medium text-stone-900">{c.title}</div>
                    <div className="text-xs text-stone-500 mt-1">{projName(c.project_id)}</div>
                    <div className={`text-xs mt-1 flex items-center gap-1 ${overdue ? "text-rose-700 font-medium" : "text-stone-600"}`}>
                      {overdue && <AlertCircle className="w-3 h-3" />}
                      Due {c.due_date} · {c.status}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-stone-400 py-12">No compliance items yet</div>}
      </div>
    </div>
  );
}
